"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const uuid_1 = require("uuid");
const exception_1 = require("@almservices-cl/exception");
class Observable {
    constructor(name = "unnamed") {
        this.isValueSet = false;
        this.value = null;
        this.error = null;
        this.errorHandlers = [];
        this.successHandlers = new Map();
        this.defaultValue = undefined;
        this.onSuccess = (successHandler, id = (0, uuid_1.v4)()) => {
            this.successHandlers.set(id, successHandler);
            if (this.isValueSet) {
                successHandler(this.value);
            }
            return this;
        };
        this.setValue = (value) => {
            this.value = value;
            this.error = null;
            this.isValueSet = true;
            this.successHandlers.forEach((handler) => {
                handler(this.value);
            });
        };
        this.setError = (error) => {
            this.error = error;
            this.isValueSet = false;
            this.value = null;
            this.errorHandlers.forEach((handler) => {
                handler(this.error);
            });
        };
        this.asPromise = () => {
            return new Promise((resolve, reject) => {
                this.onSuccess((value) => {
                    if (value === null) {
                        if (this.defaultValue !== undefined) {
                            return resolve(this.defaultValue);
                        }
                        return reject(new exception_1.OutOfRangeException(`${this.name} Value is not present`));
                    }
                    resolve(value);
                }).onError(reject);
            });
        };
        this.name = name;
    }
    onError(errorHandler) {
        if (this.error != null) {
            errorHandler(this.error);
        }
        this.errorHandlers.push(errorHandler);
        return this;
    }
    // TODO: Fix implemenation and casting in usages
    withDefault(defaultValue) {
        this.defaultValue = defaultValue;
        // it makes you able to return already casted Observable with empty object for map usages
        return this;
    }
    clear() {
        this.isValueSet = false;
        this.value = null;
        this.error = null;
    }
    removeSuccessHandler(id) {
        this.successHandlers.delete(id);
        return this;
    }
}
exports.default = Observable;
//# sourceMappingURL=Observable.js.map